<template>
  <div>
    <b-card>
      <b-row class="align-items-center justify-content-between g-0">
        <b-col class="text-center" cols="auto">
          <div style="position: relative; display: inline-block;">
            <img :src="require('@/assets/images/login1.png')" alt="Institution Logo" class="img-fluid mx-auto d-block"
              style="width: 60px; height: auto; border-radius: 10%; filter: brightness(0);" />
            <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; 
               background-color: #add8e6; mix-blend-mode: screen; 
               border-radius: 10%; pointer-events: none;">
            </div>
          </div>
        </b-col>
        <b-col class="text-center" cols="auto">
          <p class="institution-name" style="font-size: 2.5rem; font-weight: bold; color: #34495e; 
           font-family: 'Georgia', serif; text-transform: uppercase; margin: 0; margin-left: 120px;">
            {{ instituteName || '-' }}
          </p>
        </b-col>
        <b-col class="text-right" cols="auto" v-if="!from_parent_login && !show_basic_info_only">
          <b-button class="text-right" variant="info" style="font-size: 1rem; font-weight: 600; padding: 8px 15px; 
             margin-right: 10px; display: inline-flex; align-items: center;" @click="showDownloadPopup()">Download
          </b-button>
        </b-col>
      </b-row>

      <!-- Login Info -->
      <div class="section-container">
        <b-row align-v="center">
          <b-col>
            <h6 class="text-uppercase font-weight-bold">
              <i class="fas fa-user-lock mr-2" style="font-size: 20px !important;"></i>Login Info
            </h6>
          </b-col>
        </b-row>

        <b-row class="py-1 align-items-center border-bottom">
          <b-col md="2" sm="6" class="capitalize">User Name</b-col>
          <b-col md="4" sm="6">{{ profile.user.username || '-' }}</b-col>

          <b-col md="2" sm="6" class="capitalize">Email</b-col>
          <b-col md="4" sm="6">
            {{ profile.user.email || '-' }}
            <!-- <i class="fas fa-edit ml-2 text-info pointer" @click="editEmailOrMobile(true)"></i> -->
          </b-col>
        </b-row>

        <b-row class="py-1 align-items-center border-bottom">
          <b-col md="2" sm="6" class="capitalize">Mobile</b-col>
          <b-col md="4" sm="6">
            {{ profile.user.mobile || '-' }}
            <!-- <i class="fas fa-edit ml-2 text-info pointer" @click="editEmailOrMobile(false)"></i> -->
          </b-col>
        </b-row>

        <b-modal id="editUserData" :title="emailEdit
          ? `Change Email for ${profile.first_name} ${profile.last_name}`
          : `Change Mobile ${profile.first_name} ${profile.last_name}`
          " no-close-on-backdrop no-close-on-keyboard no-close-on-esc hide-header-close hide-footer size="md" centered
          modal-class="editUserData">
          <EditLoginDetails :emailEdit="emailEdit" @closeModal="$bvModal.hide('editUserData')"
            @profileUpdated="getUserProfile" />
        </b-modal>
      </div>

      <!-- General Details -->
      <div class="section-container mt-3">
        <b-row align-v="center">
          <b-col>
            <h6 class="text-uppercase font-weight-bold">
              <i class="fas fa-user mr-2" style="font-size: 20px !important;"></i>General Details
            </h6>
          </b-col>
          <b-col class="text-right">
            <i class="fas fa-edit pointer text-info" style="font-size: 18px !important;" @click="editProfileGeneralDetails"></i>
          </b-col>
        </b-row>

        <b-row class="py-1 align-items-center border-bottom">
          <b-col md="2">Name</b-col>
          <b-col md="4">{{ formattedProfile.name }}</b-col>

          <b-col md="2">Gender</b-col>
          <b-col md="4">{{ formattedProfile.gender }}</b-col>
        </b-row>

        <b-row class="py-1 align-items-center border-bottom">
          <b-col md="2">Date of Birth</b-col>
          <b-col md="4">{{ formattedBirthDate }}</b-col>

          <b-col md="2">Blood Group</b-col>
          <b-col md="4">{{ formattedProfile.blood_group }}</b-col>
        </b-row>

        <b-row class="py-1 align-items-center border-bottom">
          <b-col md="2">Category</b-col>
          <b-col md="4">{{ formattedProfile.category }}</b-col>
        </b-row>


        <EditProfileGeneralDetails v-if="isEditProfileGeneralDetails" :profile="profile"
          @profileUpdated="getUserProfile" @profileCancelled="handleProfileCancelled" />
      </div>



      <!-- Contact Details -->
      <div class="section-container mt-3">
        <b-row align-v="center">
          <b-col>
            <h6 class="text-uppercase font-weight-bold">
              <i class="fas fa-address-book mr-2" style="font-size: 20px !important;"></i>Contact Details
            </h6>
          </b-col>
          <b-col class="text-right">
            <i class="fas fa-edit pointer text-info" style="font-size: 18px !important;" @click="editProfileContactDetails"></i>
          </b-col>
        </b-row>

        <b-row class="py-1 align-items-center border-bottom">
          <b-col md="2">Email</b-col>
          <b-col md="4">{{ profile.email || '-' }}</b-col>

          <b-col md="2">Phone</b-col>
          <b-col md="4">{{ profile.mobile || '-' }}</b-col>
        </b-row>

        <b-row class="py-1 align-items-center border-bottom">
          <b-col md="2">Present Address</b-col>
          <b-col md="4">{{ formattedPresentAddress }}</b-col>

          <b-col md="2">Permanent Address</b-col>
          <b-col md="4">{{ formattedPermanentAddress }}</b-col>
        </b-row>

        <b-row class="py-1 align-items-center border-bottom">
          <b-col md="2">Office Address</b-col>
          <b-col md="4">{{ formattedOfficeAddress }}</b-col>
        </b-row>

        <EditProfileContactDetails v-if="isEditContact" :profile="profile" @profileUpdated="getUserProfile"
          @profileCancelled="handleProfileCancelled" />

      </div>

      <!-- Work Details -->
      <div class="section-container mt-3">
        <b-row align-v="center">
          <b-col>
            <h6 class="text-uppercase font-weight-bold">
              <i class="fas fa-briefcase mr-2" style="font-size: 20px !important;"></i>Current Work Details
            </h6>
          </b-col>
          <b-col class="text-right">
            <i class="fas fa-edit pointer text-info" style="font-size: 18px !important;" @click="editProfileWorkDetails"></i>
          </b-col>
        </b-row>

        <b-row class="py-1 align-items-center border-bottom">
          <b-col md="2">Institution</b-col>
          <b-col md="4">{{ profile.institute_name || '-' }}</b-col>

          <b-col md="2">Contract Type</b-col>
          <b-col md="4">{{ profile.contract_type || '-' }}</b-col>
        </b-row>

        <b-row class="py-1 align-items-center border-bottom">
          <b-col md="2">Department</b-col>
          <b-col md="4">{{ profile.department_name || '-' }}</b-col>

          <b-col md="2">Designation</b-col>
          <b-col md="4">{{ profile.designation || '-' }}</b-col>
        </b-row>

        <b-row class="py-1 align-items-center border-bottom">
          <b-col md="2">Staff ID</b-col>
          <b-col md="4">{{ profile.staff_id || '-' }}</b-col>
        </b-row>

        <EditProfileWorkDetails v-if="isEditProfileWorkDetails" :profile="profile" @profileUpdated="getUserProfile"
          @profileCancelled="handleProfileCancelled" />
      </div>

      <b-modal v-model="showModal" title="Download Options" hide-footer>
        <div>
          <b-form-group label="Choose download type:">
            <b-form-radio v-model="downloadOption" name="download-option" value="without">
              Without Institution Header
            </b-form-radio>
            <b-form-radio v-model="downloadOption" name="download-option" value="with">
              With Institution Header
            </b-form-radio>
          </b-form-group>

          <div class="text-right">
            <b-button variant="primary" @click="downloadFacultyRecord()">Download</b-button>
            <b-button variant="secondary" @click="showModal = false">Cancel</b-button>
          </div>
        </div>
      </b-modal>

      <!-- Other Sections -->
      <UserQualification :profile="profile" :profileId="profileId"/>
      <UserExperience :profile="profile" :profileId="profileId"/>
      <SubjectsEngaged :profile="profile" :profileId="profileId"/>
      <UserPublication :profile="profile" :profileId="profileId" />
      <ProgramsAttended :profile="profile" :profileId="profileId"/>
      <UserConsultancy :profile="profile" :profileId="profileId"/>
      <UserInteractions :profile="profile" :profileId="profileId" />
      <UserPositions :profile="profile" :profileId="profileId"/>
    </b-card>
  </div>
</template>

<script>
// same script you had, no big changes
import EditProfileGeneralDetails from "./UserOptions/EditProfileGeneralDetails.vue";
import EditProfileContactDetails from "./UserOptions/EditProfileContactDetails.vue";
import EditLoginDetails from "./UserOptions/EditLoginDetails.vue";
import EditProfileWorkDetails from "./UserOptions/EditProfileWorkDetails.vue";
import UserQualification from "./UserOptions/UserQualification.vue";
import UserExperience from "./UserOptions/UserExperience.vue";
import SubjectsEngaged from "./UserOptions/SubjectsEngaged.vue";
import UserPublication from "./UserOptions/UserPublication.vue";
import ProgramsAttended from "./UserOptions/ProgramsAttended.vue";
import UserConsultancy from "./UserOptions/UserConsultancy.vue";
import UserInteractions from "./UserOptions/UserInteractions.vue";
import UserPositions from "./UserOptions/UserPositions.vue";

export default {
  async created() {
    this.profileId = this.$route.params.profileId ?? '';
    await this.getProfile();
  },
  components: {
    EditProfileGeneralDetails,
    EditProfileContactDetails,
    EditLoginDetails,
    EditProfileWorkDetails,
    UserQualification,
    UserExperience,
    SubjectsEngaged,
    UserPublication,
    ProgramsAttended,
    UserConsultancy,
    UserInteractions,
    UserPositions
  },
  data() {
    return {
      isEditProfileGeneralDetails: false,
      isEditContact: false,
      emailEdit: false,
      isEditProfileWorkDetails: false,
      instituteName: null,
      profile: null,
      showModal: false,
      downloadOption: "with",
      profileId: '',
    };
  },
  computed: {
    formattedProfile() {
      if (!this.profile) return {};
      const capitalize = (str) =>
        str ? str.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase()) : '';
      return {
        name: capitalize(`${this.profile.first_name || ''} ${this.profile.last_name || ''}`.trim()),
        gender: this.profile.gender ? capitalize(this.profile.gender) : '-',
        birth_date: this.profile.birth_date || '-',
        blood_group: this.profile.blood_group ? this.profile.blood_group.toUpperCase() : '-',
        category: this.profile.category ? capitalize(this.profile.category) : '-',
      };
    },
    formattedBirthDate() {
      if (!this.profile?.birth_date) return '-';
      const date = new Date(this.profile.birth_date);
      return date.toLocaleDateString('en-GB');
    },
    formattedPresentAddress() {
      return this.getFormattedAddress(
        this.profile.present_house_name,
        this.profile.present_town,
        this.profile.present_pincode,
        this.profile.present_district,
        this.profile.present_state,
        this.profile.present_country
      );
    },
    formattedPermanentAddress() {
      return this.getFormattedAddress(
        this.profile.permanent_house_name,
        this.profile.permanent_town,
        this.profile.permanent_pincode,
        this.profile.permanent_district,
        this.profile.permanent_state,
        this.profile.permanent_country
      );
    },
    formattedOfficeAddress() {
      return this.getFormattedAddress(
        this.profile.office_house_name,
        this.profile.office_town,
        this.profile.office_pincode,
        this.profile.office_district,
        this.profile.office_state,
        this.profile.office_country
      );
    },
  },
  methods: {
    showDownloadPopup() {
      this.showModal = true;
    },
    async downloadFacultyRecord() {
      this.showModal = false;
      this.loadingPdf = true;
      const url = `${this.$store.getters.getAPIKey.mainAPI}/userprofiles/pdfexport`;

      try {
        const response = await this.$axios.post(url, this.downloadOption, { responseType: 'blob' });

        const urlBlob = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = urlBlob;
        link.setAttribute('download', 'Faculty Profile.pdf');
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        this.$toast.error('Failed to download', {
          position: 'top',
          duration: 7000,
        });
      } finally {
        this.loadingPdf = false;
      }
    },
    async getProfile() {
      try {
        const url = `${this.$store.getters.getAPIKey.mainAPI}/myprofile?profileId=${this.profileId}`;
        const response = await this.$axios.get(url);
        this.profile = response.data;
        if (this.profile?.user?.settings?.default_institute) {
          await this.getInstitution(this.profile.user.settings.default_institute);
        }
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    },
    async getInstitution(institutionId) {
      try {
        const url = `${this.$store.getters.getAPIKey.mainAPI}/institutions/${institutionId}`;
        const response = await this.$axios.get(url);
        this.instituteName = response.data.name;
      } catch (error) {
        console.error("Error fetching institution:", error);
      }
    },
    getFormattedAddress(house, town, pincode, country, state, district) {
      return [house, town, pincode, country, state, district].filter((field) => field).join(', ');
    },
    editEmailOrMobile(status) {
      this.emailEdit = status;
      this.$bvModal.show("editUserData");
    },
    editProfileGeneralDetails() {
      this.isEditProfileGeneralDetails = true;
    },
    editProfileContactDetails() {
      this.isEditContact = true;
    },
    editProfileWorkDetails() {
      this.isEditProfileWorkDetails = true;
    },
    async getUserProfile() {
      this.isEditProfileGeneralDetails = false;
      this.isEditContact = false;
      await this.getProfile();
    },
    handleProfileCancelled() {
      this.isEditProfileGeneralDetails = false;
      this.isEditContact = false;
      this.isEditProfileWorkDetails = false;
      if (this.profileId) {
        this.$router.resolve({
          name: 'MyProfileNewFromStudentStaffList',
          params: {
            profileId: this.profileId,
          },
        });
      }
      else {
        this.$router.push({ name: 'MyProfile' });
      }

    },
  },
};
</script>

<style scoped>
.section-container {
  padding: 14px;
  background-color: #f9f9f9;
  border-radius: 0px;
  margin-bottom: 20px;
}
.capitalize {
  text-transform: capitalize;
}

.pointer {
  cursor: pointer;
}

.image-container {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 60px;
}

.image-container img {
  width: 100%;
  height: auto;
  border-radius: 10%;
  filter: brightness(0);
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #add8e6;
  mix-blend-mode: screen;
  border-radius: 10%;
  pointer-events: none;
}
</style>